// app/javascript/application.js
import "@hotwired/turbo-rails"
import "./controllers"

import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle"
window.bootstrap = bootstrap



import "./navbar_dropdowns"

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    bootstrap.Dropdown.getOrCreateInstance(el)
  })
})

import "trix"
import "@rails/actiontext"

import "./src/zoom_modal" // keep if you use it

import "./src/lineage_tree"

import "./src/family_chart_adapter"

import "./src/family_tree_adapter"

import "./paypal_membership_checkout"

import "./paypal_donation_checkout"

// import TomSelect from "tom-select"
// import "tom-select/dist/css/tom-select.css"

// function initBadgesTooltips() {
//   document
//     .querySelectorAll('[data-bs-toggle="tooltip"]')
//     .forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el))
// }

// document.addEventListener("turbo:load", initBadgesTooltips)

// document.addEventListener("turbo:load", () => {
//   document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
//     new bootstrap.Tooltip(el, { delay: { show: 100, hide: 50 } })
//   })
// })

function initBadgesTooltips() {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => {
      bootstrap.Tooltip.getOrCreateInstance(el, {
        delay: { show: 100, hide: 50 }
      })
    })
}

document.addEventListener("turbo:load", initBadgesTooltips)

